import {Space,  Spin } from 'antd';
import React from "react";



const PageLoading = ()=>{


  return <Space direction='vertical' justify='center' align='center' style={{ 'height': '100vh','width': '100vw',justifyContent: 'center' }}>
    <Spin size="large" />
  </Space>
}


export default PageLoading